import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BackofficeOrganizationBookingsTableComponent } from './organization-bookings-table/backoffice-organization-bookings-table.component';
import { AuthorizationRouteGuard, FeatureToggleRouteGuard } from '@markant-platform/shared/route-guard/feature';
import { StaticRole } from '@markant-platform/shared/user/model';
import { AppConfigService, AppFeature, RoleSpecificRouteDataItem } from '@markant-platform/shared/data-access';
import { isOrgNewAndLvl3 } from '@markant-platform/shared/util-helpers';

const routes: Routes = [
  {
    path: '',
    component: BackofficeOrganizationBookingsTableComponent,
  },
  {
    path: 'management/:bookingId',
    loadChildren: () =>
      import('@markant-platform/cartridge/feature-management-view').then(m => m.CartridgeFeatureManagementViewModule),
  },
  {
    path: 'price-requests',
    canActivate: [FeatureToggleRouteGuard, AuthorizationRouteGuard(StaticRole.ORGANIZATION_ADMIN)],
    data: {
      disabled: !AppConfigService.isFeatureEnabled(AppFeature.PRICE_REQUEST),
      translationKey: 'priceRequests',
      onlyRoles: [StaticRole.ORGANIZATION_ADMIN],
      roleSpecificData: {
        [StaticRole.ORGANIZATION_ADMIN]: {
          route: 'organization-administrator',
          translationKey: 'myPriceRequests',
        } as RoleSpecificRouteDataItem,
      },
      condition: { role: StaticRole.ORGANIZATION_ADMIN, func: isOrgNewAndLvl3 },
    },
    loadChildren: () =>
      import('@markant-platform/backoffice/feature-price-requests').then(m => m.BackofficeFeaturePriceRequestModule),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class BackofficeFeatureOrganizationBookingsRoutingModule {}
